// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".count_box[data-v-40cdea52]{border-radius:4px;background-color:rgba(255,57,115,.05);color:#d50000;font-size:14px;height:40px;line-height:40px;margin:40px;text-align:center}.count_box .iconfont[data-v-40cdea52]{margin-right:6px}", ""]);
// Exports
module.exports = exports;
